<!-- Header Image-->
@if (showHeaderImage) {
  <div class="header-background" [style.background-image]="'url(' + questionDetails.headerImageUrl + ')'">
  </div>
  <div class="text-area"></div>
}
<!-- Mask Image-->
<div class="col-md-4" style="padding-left: 0px;  padding-right: 0px;">
  @if (showMaskImage) {
    <img class="mask-image" style="max-height: 200px" src={{surveyData.maskUrl}} />
  }
</div>
<!-- Question -->
<div [ngClass]="showHeaderImage ? 'header-survey-section header-positioned' : 'c-survey__section survey-question'">
  @for (text of questionDetails.QuestionText; track text) {
    <h2 [attr.headerid]="text" class="c-survey__question is-multi-question">{{ text | translate: { firstName: surveyData?.firstName, maskName: surveyData?.maskName } }}</h2>
  }
</div>

@if (questionDetails?.ShowInfoButton) {
  <span id="infoModalBtn" class="material-icons info" type="button" (click)="displayInfoModal()">info_outline</span>
}

<!-- Button style answer choices list -->
<div [ngClass]="showHeaderImage ? 'header-survey-section header-positioned-choices' : 'c-survey__section survey-choices'">
  @for (answer of questionDetails.PossibleAnswers; track answer; let i = $index) {
    <span>
      <button type="button" [attr.answerId]="answer.AnswerId" class="c-survey__answer-single-select" [ngClass]="activeIndex === i ? 'is-active' : '' " (click)="activeIndex = i; this.answerSelected(answer, i)">{{answer.AnswerText | translate}}</button>
      @if (answer.FreeText && activeIndex === i) {
        <div class="c-form-field u-text-align-left">
          <label class="c-form-field__label">{{'describe' | translate}}</label>
          <div class="c-form-field__input">
            <input maxlength="100" type="text" class="c-input c-input--text" [(ngModel)]="answer.Description" (ngModelChange)="this.answerSelected(answer, i)">
          </div>
          <div class="c-form-field__hint">
            {{ 'enter-description' | translate }}
          </div>
        </div>
      }
    </span>
  }
</div>
